<template>
  <div class="other-bill-type-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-confirm value="添加" :iconClass="'el-icon-plus'" @confirm="showDialogVisible" v-if="permissionCodes.indexOf('002012001') !== -1"/>
      </div>
      <input-search placeholder="类型名称" @search="searchKey" />
    </div>

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该账单类型？'" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />

    <el-dialog title="添加账单类型" :visible.sync="dialogVisible" width="600">
      <form>
        <div class="form-line" v-for="(item, index) in typeNameList">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">类型名称：</span>
          </div>
          <el-input v-model="item.name" size="small" style="width: 280px" />
          <div style="width: 80px">
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addTypeNameLine()" v-if="index === typeNameList.length - 1"></i>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeTypeNameLine(index)" v-if="index > 0"></i>
          </div>
        </div>

      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelAddOtherBillType">取 消</el-button>
        <el-button size="small" type="primary" @click="addOtherBillType">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/InvestmentLeasing'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'other-bill-type-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '其他合约',
        name: 'other-custom-management'
      }, {
        value: '账单类型'
      }],
      tableHead: [{
        prop: 'name',
        label: '类型名称'
      }, {
        prop: 'createTime',
        label: '创建时间',
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: '',
      },
      operationArr: ['delete'],

      dialogVisible: false,
      typeNameList: [
        {name: ''}
      ],

    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios.post(api.getOtherBillTypePage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    search (v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    showDialogVisible () {
      this.dialogVisible = true
      this.typeNameList = [
        {name: ''}
      ]
    },
    // 增加类型名称
    addTypeNameLine() {
      let obj = {
        name: ''
      };
      this.typeNameList.push(obj);
    },
    // 删减类型名称
    removeTypeNameLine(index) {
      this.typeNameList.splice(index, 1);
    },
    // 取消添加
    cancelAddOtherBillType () {
      this.dialogVisible = false
      this.typeNameList = [
        {name: ''}
      ]
    },
    // 添加账单类型
    addOtherBillType () {
      let typeNameArr = []
      this.typeNameList.map(v => {
        if (v.name) {
          typeNameArr.push(v.name)
        }
      })
      if (typeNameArr.length === 0) {
        nError('请输入类型名称')
        return false
      }
      this.$axios.post(api.addOtherBillType, typeNameArr)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.dialogVisible = false
            this.typeNameList = [
              {name: ''}
            ]
            this.getPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    deleteLine (code) {
      this.$axios.post(api.deleteOtherBillTypeByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    }
  },
  watch: {}
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/OtherBillTypeManage.vue